import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { GlassCard, Skeleton } from "@/v2/components/ui";
import { Lock, LogIn, Award, Flame, Zap, Milestone, Crown, Trophy } from "lucide-react";

const ICONS = { LogIn, Award, Flame, Zap, Milestone, Crown, Trophy };

export default function Badges() {
  const { data = [], isLoading } = useQuery({ queryKey: ["badges"], queryFn: async () => (await api.get("/badges")).data });
  const earned = data.filter((b) => b.earned).length;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold flex items-center gap-2"><Award className="text-[#e3c799]" /> الشارات</h1>
        <p className="text-[#bcc8cf] mt-1">حصلت على {earned} من {data.length} شارة.</p>
      </div>
      {isLoading ? <Skeleton className="h-64 w-full" /> : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.map((b, i) => { const I = ICONS[b.icon] || Award; return (
            <motion.div key={b.id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}>
              <GlassCard gold={b.earned} hover={b.earned} data-testid={`v2-badge-${b.id}`} className={`p-6 flex items-center gap-4 ${b.earned ? "" : "opacity-60"}`}>
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center shrink-0 ${b.earned ? "bg-gradient-to-br from-[#e3c799] to-[#bb9661] text-[#25343f] v2-glow-gold" : "bg-white/5 text-[#bcc8cf]"}`}>{b.earned ? <I size={30} /> : <Lock size={24} />}</div>
                <div>
                  <div className="font-bold">{b.name}</div>
                  <div className="text-sm text-[#bcc8cf]">{b.desc}</div>
                  <div className={`text-xs font-bold mt-1 ${b.earned ? "text-[#91cab8]" : "text-[#bcc8cf]"}`}>{b.earned ? "تم الحصول عليها" : "مقفلة"}</div>
                </div>
              </GlassCard>
            </motion.div>
          ); })}
        </div>
      )}
    </div>
  );
}
